export var PermissionType;
(function (PermissionType) {
    PermissionType[PermissionType["viewPermission"] = 0] = "viewPermission";
    PermissionType[PermissionType["createPermission"] = 1] = "createPermission";
    PermissionType[PermissionType["editPermission"] = 2] = "editPermission";
    PermissionType[PermissionType["deletePermission"] = 3] = "deletePermission";
})(PermissionType || (PermissionType = {}));
